import {toURL} from '@homeaway/search-url-parser';

export const getPrefix = () => window.location.pathname.split('/')[1] || 'd';

export const buildSerpUrl = ({host, params}) => toURL(params, {hostname: host});
